import { loadStripe } from "@stripe/stripe-js";
import { isVersionUK } from "./versionService";
import { isLocal, isUKDevelopment, isUSDevelopment } from "./serviceConfig";
import { brownBold, brownLight, brownRegular } from "../assets/fonts/fonts";

export const STRIPE_KEY_UK_DEV = "pk_test_51PtWBtK21COG1LYIumtI5fSmfzwaoJ1pWEelnGZokvRFNnqqKFQb2KPeCWI98JXS6e3tKA3O4tBLuO32VpEnfcpX00oJfztzkl";
export const STRIPE_KEY_UK_PROD = "pk_live_51PtWBtK21COG1LYIJs50cf5jgcS7vRars3O4XWnje6SlevFKHs9NmzJcJYEyVVsdcS1qbNA9wtLkFMhvXivj5FCM00Z8yiEcbu";

export const STRIPE_KEY_US_DEV = "pk_test_51P4lDDK8ZkBXBaUWm3Rer7Azn2eK1GswNgARkyMQHzOzCtT3pA66xsU7eefqsQLUIn3IeWwrqDSwOGXaA5Wc9lG400mj9lOLgT";
export const STRIPE_KEY_US_PROD = "pk_live_51P4lDDK8ZkBXBaUWq7yysDoCDFCfJjgtNdzNuUGiUWWZ1SiUUyRjtp9QBVCCK4gXeFfPMvxNXojpuH1unwItu8Jq00q3ERr80Z";

export const STRIPE_KEY_DEV = isVersionUK ? STRIPE_KEY_UK_DEV : STRIPE_KEY_US_DEV;
export const STRIPE_KEY_PROD = isVersionUK ? STRIPE_KEY_UK_PROD : STRIPE_KEY_US_PROD;

export const stripePromise = loadStripe(isUKDevelopment || isUSDevelopment || isLocal ? STRIPE_KEY_DEV : STRIPE_KEY_PROD);

export const stripeAppearance = {
    theme: "stripe",
    variables: {
        colorPrimary: "#153256",
        colorText: "#1D1D1B",
        colorDanger: "#df1b41",
        fontFamily: isVersionUK ? "Brown" : "Barlow",
        spacingUnit: "4px",
        borderRadius: "4px",
    },
    inputs: "spaced",
    rules: {
        ".Input": {
            border: "2px solid #DEDBDD",
            boxShadow: "none",
            marginBottom: "6px",
        },
        ".Input:focus": {
            border: "2px solid #DEDBDD",
            boxShadow: "0 0 0 1px #4caf50",
        },
        ".Label": {
            fontWeight: "400",
            fontSize: "16px",
            marginBottom: "4px",
            color: "#000000",
        },
        ".TermsText": {
            lineHeight: 1.2,
        },
        ".AccordionItem": {
            border: "2px solid #E3E2E2",
            padding: "16px",
            boxShadow: "none",
            backgroundColor: "#F8F8F8",
        },
        ".AccordionItem--selected": {
            backgroundColor: "#ffffff",
        },
    },
};
export const stripeFonts = [
    {
        cssSrc: "https://fonts.googleapis.com/css2?family=Barlow:wght@400;500;600;700&display=swap",
    },
    {
        family: "Brown",
        src: `url(${brownRegular}) format("woff2")`,
        weight: "400",
    },
    {
        family: "Brown",
        src: `url(${brownLight}) format("woff2")`,
        weight: "300",
    },
    {
        family: "Brown",
        src: `url(${brownBold}) format("woff2")`,
        weight: "600",
    },
];
export const stripeCurrency = isVersionUK ? "gbp" : "usd";
